/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getQuoteRequests } from "api/services/quoteRequest";
import { quoteRequestQueryKeys } from "./quoteRequestQueryKeys";

export const useGetQuoteList = (filters: any, options: UseQueryOptions) =>
  useQuery({
    queryKey: quoteRequestQueryKeys.quoteListing(filters),
    queryFn: ({ signal }) => getQuoteRequests({ params: filters, signal }).then((res) => res.data),
    ...options,
  });
